module.exports = __webpack_public_path__ + "DSC05527.4ea5b678d0c4583c71db.jpg";